import React, { useEffect, useState, useRef, Suspense } from 'react'
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, setChatDocView } from '../../../../Actions/AllAction';
import * as DashboardController from '../Controller/DashboardController';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);

function CampaignChart(props) {

    const [dataset, setDataset] = useState(null);
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        if (hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        const { loaderStateTrue, loaderStateFalse, userCredentials } = props;
        loaderStateTrue();
        const params = {
            "org_id": userCredentials.user_details.org_id,
        };
        DashboardController.loadCampaignGet(params)
            .then((response) => {
                setDataset(response);
            })
            .catch((error) => {
                console.error("************error*************", error)
            })
            .finally(() => {
                loaderStateFalse();
            });
    }, []);

    const loadCampaignChart = () => {
        if (!dataset) {
            return null;
        }
        let neutral_response = 0;
        let total_delivered = 0;
        let total_campaign = 0;
        let positive_response = 0;
        let negative_response = 0;
        if (dataset.success && dataset.data && dataset.data.total_delivered > 0) {
            total_delivered = dataset.data.total_delivered || 0;
            total_campaign = dataset.data.total_campaign_count || 0;
            neutral_response = dataset.data.total_delivered - (dataset.data.positive_response + dataset.data.negative_response);
            positive_response = dataset.data.positive_response;
            negative_response = dataset.data.negative_response;
        }
        // If there is no data, show a clean empty state and skip rendering the chart
        if (!dataset.success || !dataset.data || !dataset.data.total_delivered) {
            return (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#605d5d', fontSize: '13px', fontFamily: 'Poppins-Medium' }}>
                    No data available
                </div>
            );
        }
        const doughnutValueLabels = {
            id: 'doughnutValueLabels',
            afterDatasetsDraw(chart, args, pluginOptions) {
                const { ctx } = chart;
                const dataset = chart.data.datasets[0];
                if (!dataset) return;
                ctx.save();
                chart.getDatasetMeta(0).data.forEach((arc, index) => {
                    const value = dataset.data[index];
                    if (!value) return;
                    const pos = arc.tooltipPosition();
                    ctx.fillStyle = '#ffffff';
                    ctx.font = 'bold 12px sans-serif';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(value, pos.x, pos.y);
                });
                ctx.restore();
            }
        };
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'right',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
            },
            y: {
                ticks: {
                    stepSize: 1,
                },
            },
        };
        let data = {
            labels: [`Positive Response`, `Negative Response`, `Neutral Response`],
            datasets: [
                {
                    label: '# of Votes',
                    data: [positive_response, negative_response, neutral_response],
                    backgroundColor: [
                        "#00A651",
                        "#F15A29",
                        "#FFD100",
                    ],
                    borderColor: [
                        "#00A651",
                        "#F15A29",
                        "#FFD100",
                    ],
                    borderWidth: 1,
                },
            ],
        }
        return (
            <>
                <div className='campaign_val_footer'>Total Campaign: {total_campaign}</div>
                <div className='chart_text_val_footer'>Total Delivered Messages: {total_delivered}</div>
                <Doughnut data={data} options={options} plugins={[doughnutValueLabels]} />
            </>
        )
    }

    return (
        <div style={{ width: '330px', height: '280px', margin: '0px 0px' }}>
            {loadCampaignChart()}
        </div>
    );
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userLoginDetails: globalState.LoginReducer.userLoginDetails,
        token: globalState.LoginReducer.token,
        localTimeZoneName: globalState.mainReducerData.localTimeZone,
        version: globalState.LoginReducer.version,
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setChatDocView })(withRouter(CampaignChart));